import { Button } from '@/components/ui/button'
import useModalStore from '@/stores/useModalStore'
import { Flag, FlagOff, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { updateChat } from '../../graphql/mutation'
import { useMutationGraphQL } from '@/use-graphql'
import { Tooltip } from '@/components/ToolTip'
import { useState } from 'react'
import { toast } from 'react-toastify'

const FlagChatButton = ({ id, flagged }: { id: string; flagged: boolean }) => {
  const { addModal } = useModalStore()
  const { t } = useTranslation()
  const updateFlaggedStateOfChat = useMutationGraphQL(
    updateChat,
    { id, input: { flagged: !flagged } },
    {
      onSuccess: () => {
        window.location.reload()
      },
      onError: () => {
        toast.error('Failed to flag chat')
      },
    },
  )

  const showConfirmModal = () => {
    addModal({
      name: 'send-email-notification',
      Component: ({ close }) => {
          const [loading, setLoading] = useState(false)
          return (
          <div className="p-10">
            <h3>Do you want to {flagged ? 'unflag' : 'flag'} this Chat?</h3>
            <div className="mt-10 flex justify-end gap-4">
              <Button
                onClick={async () => {
                  try{
                    setLoading(true)
                    await updateFlaggedStateOfChat.mutateAsync()
                    setTimeout(() => close?.(), 300)
                  } finally {
                    setLoading(false)
                  }
                }}
                disabled={loading}
                className="relative"
              >
                {t('button.accept')}
                {loading && <Loader2 className="absolute left-2 top-3 animate-spin !text-white" size={20} />}
              </Button>
              <Button variant="outline" onClick={close}>
                {t('button.cancel')}
              </Button>
            </div>
          </div>
        )
      },
      isCardStyle: true,
      maxWidth: 700,
    })
  }

  return (
    <button onClick={showConfirmModal} className="hover:text-brand-valencia">
      <Tooltip
        content={flagged ? 'Unflag' : 'Flag'}
        delayDuration={100}
        className="bg-slate-800/70 text-xs text-white"
      >
        {flagged ? <FlagOff size={18} /> : <Flag size={20} />}
      </Tooltip>
    </button>
  )
}

export default FlagChatButton
